import Vue from 'vue'
import Router from 'vue-router'

import Frame from '@/app/Frame'
import Page404 from '@/pages/404/404'
import DispatchHome from '@/app/DispatchHome'

import SystemHome from '@/app/SystemHome'
import Clazz from '@/app/Clazz'
import Student from '@/app/Student'
import CourseChoose from '@/app/CourseChoose'
import CourseTask from '@/app/CourseTask'
import Course from '@/app/Course'
import Staff from '@/app/Staff'
import Award from '@/app/Award'
import Eval from '@/app/Eval'
import EvalSetting from '@/app/EvalSetting'
import EvalFill from '@/app/EvalFill'

import ScoreTask from '@/app/ScoreTask'
import ScoreQuery from '@/app/ScoreQuery'
import ScoreExport from '@/app/ScoreExport'

import LogAnalysis from '@/system/loganalysis/LogAnalysis'
import SystemBillCodeIndex from '@/system/systembillcode/SystemBillCodeIndex'
import SystemDictIndex from '@/system/systemdict/SystemDictIndex'
import SystemParamIndex from '@/system/systemparam/SystemParamIndex'
import SystemMailIndex from '@/system/systemmail/SystemMailIndex'
import SystemSessionIndex from '@/system/systemsession/SystemSessionIndex'
import SystemTokenIndex from '@/system/systemtoken/SystemTokenIndex'

import SystemRoleIndex from '@/system/systemrole/SystemRoleIndex'
import SystemUserIndex from '@/system/systemuser/SystemUserIndex'
import SystemMenuIndex from '@/system/systemmenu/SystemMenuIndex'
import SystemPostIndex from '@/system/systempost/SystemPostIndex'
import SystemOrganIndex from '@/system/systemorgan/SystemOrganIndex'

import WorkFlowIndex from '@/system/workflow/WorkFlowIndex'

Vue.use(Router)

var router = new Router({
  routes: [
    {
      path: '/',
      component: Frame,
      children: [
        {path: '', redirect: 'DispatchHome'},
        {path: 'DispatchHome', component: DispatchHome, meta: {nameCn: '跳转主页'}},
        // 默认主页
        {path: 'SystemHome', component: SystemHome, meta: {nameCn: 'SystemHome'}},
        {path: 'Clazz', component: Clazz, meta: {nameCn: '班级管理'}},
        {path: 'Student', component: Student, meta: {nameCn: '学生管理'}},
        {path: 'Staff', component: Staff, meta: {nameCn: '教师管理'}},
        {path: 'CourseChoose', component: CourseChoose, meta: {nameCn: '课程选择'}},
        {path: 'CourseTask', component: CourseTask, meta: {nameCn: '选课任务'}},
        {path: 'Course', component: Course, meta: {nameCn: '课程'}},
        {path: 'ScoreTask', component: ScoreTask, meta: {nameCn: '成绩任务'}},
        {path: 'ScoreQuery/:type', component: ScoreQuery, meta: {nameCn: '成绩查询'}},
        {path: 'ScoreExport', component: ScoreExport, meta: {nameCn: '成绩导入'}},
        {path: 'Award/:ctrlType', component: Award, meta: {nameCn: '荣誉奖励'}},
        {path: 'Eval/:ctrlType', component: Eval, meta: {nameCn: '评优任务'}},
        {path: 'EvalSetting', component: EvalSetting, meta: {nameCn: '评优设定'}},
        {path: 'EvalFill/:ctrlType', component: EvalFill, meta: {nameCn: '教职工填报'}},
        // 系统
        {path: 'LogAnalysis', component: LogAnalysis, meta: {nameCn: '日志工具'}},
        {path: 'SystemParamIndex', component: SystemParamIndex, meta: {nameCn: '系统参数'}},
        {path: 'SystemBillCodeIndex', component: SystemBillCodeIndex, meta: {nameCn: '系统流水号'}},
        {path: 'SystemDictIndex', component: SystemDictIndex, meta: {nameCn: '数据字典'}},
        {path: 'SystemMailIndex', component: SystemMailIndex, meta: {nameCn: '邮件中心'}},
        {path: 'SystemSessionIndex', component: SystemSessionIndex, meta: {nameCn: 'Session管理'}},
        {path: 'SystemTokenIndex', component: SystemTokenIndex, meta: {nameCn: 'Token工具'}},
        {path: 'SystemRoleIndex', component: SystemRoleIndex, meta: {nameCn: '系统角色'}},
        {path: 'SystemUserIndex', component: SystemUserIndex, meta: {nameCn: '系统用户'}},
        {path: 'SystemMenuIndex', component: SystemMenuIndex, meta: {nameCn: '系统菜单'}},
        {path: 'SystemPostIndex', component: SystemPostIndex, meta: {nameCn: '系统职位'}},
        {path: 'SystemOrganIndex', component: SystemOrganIndex, meta: {nameCn: '系统岗位'}},
        {path: 'WorkFlowIndex', component: WorkFlowIndex, meta: {nameCn: '状态机'}},
        {path: '*', component: Page404}
      ]
    },
    {path: '*', component: Page404}
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js